import React from 'react';
import { Channel } from '../../../../../../interfaces';
import { usePlaybills } from '../../../../../../queries/playbills/queries';
import { broadcastingNow } from '../../../../../../utils/huaweiUtils';
import { ProgramCard } from '../program-card/program-card';

interface ChannelCardProps {
  channel: Channel;
  index: number;
}

export function ChannelCard({ channel, index }: ChannelCardProps) {
  const { data: programs, isLoading } = usePlaybills({ channelIds: [channel.contentId], date: new Date() });

  if (isLoading) {
    return <ChannelCardSkeleton />;
  }

  if (!programs) {
    return null;
  }

  const liveProgram = programs.find(broadcastingNow);

  if (liveProgram === undefined || programs.length === 0) {
    return null;
  }

  return <ProgramCard program={liveProgram} channel={channel} order={index} />;
}

function ChannelCardSkeleton() {
  return <ProgramCard.Skeleton />;
}

ChannelCard.Skeleton = ChannelCardSkeleton;
